// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2_mAY","label":"Section_label__2uAvA","contentWrap":"Section_contentWrap__H483z","footer":"Section_footer__1Jj2t","footerInner":"Section_footerInner__E1hNU"};